import { render, staticRenderFns } from "./ReCallClass.vue?vue&type=template&id=17ada43b&scoped=true"
import script from "./ReCallClass.vue?vue&type=script&lang=js"
export * from "./ReCallClass.vue?vue&type=script&lang=js"
import style0 from "./ReCallClass.vue?vue&type=style&index=0&id=17ada43b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ada43b",
  null
  
)

export default component.exports